import getCarrierLogoUrl from 'modules/get-carrier-logo-url/get-carrier-logo-url';
import sortByProperty from 'modules/sort-objects/sort-objects';
import { format } from 'date-fns';
import getCarrierName from 'modules/get-carrier-name/get-carrier-name';

export default function prepareManifestData({
  agency,
  packages,
  date,
  reference: title,
  preparation_order,
  generated_by,
  warehouse,
  ...manifestData
}) {
  return {
    title,
    preparation_order: preparation_order?.reference || null,
    user: generated_by?.username || '',
    create_date: format(Date.now(), 'dd-MM-yyyy HH:mm'),
    packages: sortByProperty(packages, 'sku'),
    warehouse: warehouse?.warehouse || '',
    ...(agency
      ? {
          agency: {
            name: getCarrierName(agency?.agency_code),
            logo: getCarrierLogoUrl(agency?.agency_code),
          },
        }
      : { agency: null }),
  };
}
